var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerspective02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4.99994L16 18.9999M10 3.99995L10 19.9999M3 11.9999H21M3 5.98912L3 18.0108C3 19.3748 3 20.0568 3.28134 20.5296C3.52803 20.9441 3.9162 21.2554 4.37434 21.4063C4.89685 21.5784 5.56262 21.4305 6.89418 21.1346L18.4942 18.5568C19.3883 18.3581 19.8354 18.2588 20.1691 18.0183C20.4634 17.8063 20.6945 17.5182 20.8377 17.1848C21 16.8069 21 16.3489 21 15.433V8.5669C21 7.65096 21 7.193 20.8377 6.81508C20.6945 6.48174 20.4634 6.19361 20.1691 5.98155C19.8354 5.74114 19.3883 5.64179 18.4942 5.4431L6.89418 2.86532C5.56262 2.56942 4.89685 2.42147 4.37434 2.59356C3.9162 2.74445 3.52803 3.05583 3.28134 3.47033C3 3.94306 3 4.62508 3 5.98912Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerspective02);
export default __webpack_public_path__ + "static/media/perspective-02.943bf26d4522e999356982a79be88914.svg";
export { ForwardRef as ReactComponent };